import 'css-chunksrc/feature/provision/ClaimTerminal.module.scss';export default {
  "notice": "ClaimTerminal_notice"
};